import * as SliderPrimitive from '@radix-ui/react-slider';
import { styled } from '../../../stitches.config';

const StyledSlider = styled(SliderPrimitive.Root, {
  position: 'relative',
  display: 'inline-flex',
  alignItems: 'center',
  userSelect: 'none',
  touchAction: 'none',
  width: '200px',
  height: '20px',
});

const StyledTrack = styled(SliderPrimitive.Track, {
  backgroundColor: '$slate6',
  position: 'relative',
  flexGrow: 1,
  borderRadius: '9999px',
  height: '3px',
});

const StyledRange = styled(SliderPrimitive.Range, {
  position: 'absolute',
  backgroundColor: '$slate10',
  borderRadius: '9999px',
  height: '100%',
});

const StyledThumb = styled(SliderPrimitive.Thumb, {
  'cursor': 'grab',
  'display': 'block',
  'width': '20px',
  'height': '20px',
  'backgroundColor': '$slate9',
  'boxShadow': '0 2px 10px $blackA7',
  'borderRadius': '10px',
  '&:hover': { backgroundColor: '$slate10' },
  '&:focus': {
    outline: 'none',
    boxShadow: '0 0 0 5px $blackA8',
  },
});

export const Slider = StyledSlider as typeof StyledSlider & {
  Track: typeof StyledTrack;
  Range: typeof StyledRange;
  Thumb: typeof StyledThumb;
};

Slider.Track = StyledTrack;
Slider.Range = StyledRange;
Slider.Thumb = StyledThumb;
